import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_183_account_master: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Account master",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 24,
        },
        childComponents: [
          {
            componentType: ComponentType.CUSTOM,
            customType: "ledgerSettingsMaster",
            name: "ledger_settings_master",
          } as ComponentConfig,
        ],
      },
    ],
  },
];
